import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import SelfAssessmentUserDetail from './SelfAssessmentUserDetail';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanySelfAssessmentUserDetail } from './companySelfAssessmentApi';

/**
 * Company Self-Assessment → one employee's/member's assessment profile.
 * Reuses the shared detail page with the company-scoped fetcher (the backend
 * 404s any user who doesn't belong to this company).
 */
const CSelfAssessmentUserDetail = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>User Assessment Profile | Shoorah</title>
      </Helmet>
      <SelfAssessmentUserDetail
        fetcher={fetchCompanySelfAssessmentUserDetail}
        backPath={`/${slug}/self-assessment/users`}
        backLabel={isB2BFansMode ? 'Back to Members' : 'Back to Employees'}
      />
    </div>
  );
};

export default CSelfAssessmentUserDetail;
